import Relay from 'react-relay';

export default class SearchDevelOrganisationsMutation extends Relay.Mutation {
    getMutation() {
        return Relay.QL`mutation { searchDevelOrganisations }`;
    }

    getVariables() {
        return {
            query: this.props.query || '',
            limit: this.props.limit || 20,
        };
    }

    getFatQuery() {
        return Relay.QL`
            fragment on SearchDevelOrganisationsPayload {
                organisations {
                    id
                    name
                    identNum
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                Relay.QL`
                    fragment on SearchDevelOrganisationsPayload {
                        organisations {
                            id
                            name
                            identNum
                        }
                    }
                `,
            ],
        }];
    }
}
